import _classCallCheck from "/workspace/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var TransactionPath = function TransactionPath(data) {
  _classCallCheck(this, TransactionPath);

  this.apps = data.apps;
  this.destination = data.destination;
  this.forwardingFeePretransaction = data.forwardingFeePretransaction;
  this.transactions = data.transactions;
};

export { TransactionPath as default };